module.exports = __webpack_public_path__ + "static/favicon-a039f1541b8492e5950d340886b5c615.ico";